// Shopify constants
window.Shopify = window.Shopify || {};

// Route constants
if (typeof window.routes === 'undefined') {
  window.routes = {};
}

// Cart constants
if (typeof window.cartStrings === 'undefined') {
  window.cartStrings = {
    error: 'There was an error while updating your cart. Please try again.',
    quantityError: 'You can only add [quantity] of this item to your cart.'
  };
}

// Variant constants
if (typeof window.variantStrings === 'undefined') {
  window.variantStrings = {
    addToCart: 'Add to cart',
    soldOut: 'Sold out',
    unavailable: 'Unavailable'
  };
}

// Theme constants
window.theme = {
  colors: {
    primary: '#C4969B',
    secondary: '#8A6871',
    background: '#F8F3F4',
    text: '#7D5E6A'
  },
  breakpoints: {
    mobile: 768,
    tablet: 1024,
    desktop: 1200
  }
};